<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item">
        <form>
          <md-card class="p-25">
            <!-- {{ canClear }} -->
            <md-card-content>
              <div class="md-layout">
                <div
                  class="md-layout-item md-size-25 md-small-size-100 ml-15 mt-25"
                >
                  <model-list-select
                    class="input-must-rtl"
                    :list="employeesList"
                    v-model="employeeId"
                    option-value="key"
                    option-text="value"
                    placeholder="الموظف"
                    @input="clearInput"
                  >
                  </model-list-select>
                </div>

                <div
                  class="md-layout-item md-size-20 md-small-size-100 mt-25 mt-25 ml-15"
                >
                  <md-field>
                    <label>رقم الموظف</label>

                    <md-input
                      v-model="JobNumber"
                      type="number"
                      @input="clearInput"
                    />
                  </md-field>
                </div>

                <div
                  class="md-layout-item md-size-25 md-small-size-100 mt-25 mt-25 ml-15"
                >
                  <md-datepicker :md-open-on-focus="false" v-model="from">
                    <label class="mr-28">تاريخ من</label>
                  </md-datepicker>
                </div>

                <div
                  class="md-layout-item md-size-25 md-small-size-100 mt-25 ml-15"
                >
                  <md-datepicker :md-open-on-focus="false" v-model="to">
                    <label class="mr-28">تاريخ إلى</label>
                  </md-datepicker>
                </div>

                <div
                  class="md-layout-item md-size-25 md-small-size-100 mtb-25"
                  style="padding-right: 0"
                >
                  <md-checkbox v-model="showSkippedLogs">
                    عرض البصمات المتجاهلة
                  </md-checkbox>
                </div>

                <div
                  class="md-layout-item md-size-100 mt-25 mtb-25 center-content"
                >
                  <md-button @click="search" class="md-success btn_nanosoft">
                    بحث
                  </md-button>
                  <md-button
                    @click="openInsertLogDialog"
                    class="md-primary btn_nanosoft"
                  >
                    إدراج بصمة
                  </md-button>
                  <md-button
                    @click="exportReport('PDF')"
                    class="md-info btn_nanosoft"
                  >
                    طباعة PDF
                  </md-button>
                  <md-button
                    @click="exportReport('EXCEL')"
                    class="md-info btn_nanosoft"
                  >
                    طباعة EXCEL
                  </md-button>
                </div>
                <div
                  v-if="isFetchShiftListLoading"
                  class="md-layout-item md-size-100 mt-25 mtb-25 center-content"
                >
                  <md-progress-spinner
                    md-mode="indeterminate"
                  ></md-progress-spinner>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </form>
      </div>
    </div>

    <div class="md-layout-item">
      <div class="employee-nav-wrapper">
        <md-button
          class="md-primary md-raised employee-nav-btn"
          :disabled="isBackDisabled"
          @click="goToPreviousEmployee"
        >
          <md-icon>chevron_right</md-icon>
          السابق
        </md-button>

        <md-button
          class="md-primary md-raised employee-nav-btn"
          :disabled="isNextDisabled"
          @click="goToNextEmployee"
        >
          التالي
          <md-icon>chevron_left</md-icon>
        </md-button>
      </div>

      <md-card>
        <md-card-content>
          <md-progress-bar
            v-if="isLoading"
            md-mode="indeterminate"
          ></md-progress-bar>

          <template>
            <md-table
              v-model="tableData"
              :md-sort.sync="currentSort"
              :md-sort-order.sync="currentSortOrder"
              :md-sort-fn="customSort"
              class="paginated-table table-striped table-hover mt-25"
            >
              <md-table-row
                slot="md-table-row"
                slot-scope="{ item, index }"
                :style="getRowStyle(item, index)"
              >
                <md-table-cell md-label="التاريخ">
                  {{ convert(item.date) }}
                </md-table-cell>

                <md-table-cell md-label="اليوم">
                  {{ item.day }}
                </md-table-cell>
                <md-table-cell md-label="الوقت">
                  {{ item.time }}
                </md-table-cell>
                <md-table-cell md-label="نوع البصمة">
                  <md-button
                    v-if="item.signType == 1 && item.status == 1"
                    class="md-success btn-style"
                    @click="openChangeTypeDialog(item)"
                  >
                    {{ item.type }}
                    <md-icon v-if="isInsertedSign(item)">
                      play_for_work
                    </md-icon>
                  </md-button>
                  <md-button
                    v-if="item.signType == 2 && item.status == 1"
                    class="md-danger btn-style"
                    @click="openChangeTypeDialog(item)"
                  >
                    {{ item.type }}
                    <md-icon v-if="isInsertedSign(item)">
                      play_for_work
                    </md-icon>
                  </md-button>
                  <md-button
                    v-if="item.signType == 0"
                    class="md-primary btn-style"
                    @click="openChangeTypeDialog(item)"
                  >
                    تغيير نوع البصمة
                  </md-button>
                  <md-button
                    v-if="item.status == 2"
                    class="md-secondary btn-style"
                    @click="openChangeTypeDialog(item)"
                  >
                    {{ item.type }}
                  </md-button>
                </md-table-cell>
                <md-table-cell md-label="آلية البصمة">
                  {{ item.signMechanismString }}
                </md-table-cell>
                <md-table-cell md-label="مكان العمل">
                  {{ item.workPlaceName }}
                </md-table-cell>

                <md-table-cell md-label="الإجراءات">
                  <div class="actions-wrapper">
                    <div class="action-slot">
                      <md-button
                        v-if="item.status == 1"
                        class="md-just-icon md-warning md-simple"
                        @click.native="handleIgnore(item)"
                      >
                        <md-tooltip md-direction="top"
                          >تجاهل البصمة</md-tooltip
                        >
                        <md-icon>block</md-icon>
                      </md-button>
                    </div>
                    <div class="action-slot">
                      <md-button
                        v-if="isInsertedSign(item)"
                        class="md-just-icon md-danger md-simple"
                        @click.native="handleDelete(item)"
                      >
                        <md-tooltip md-direction="top">حذف البصمة</md-tooltip>
                        <md-icon>close</md-icon>
                      </md-button>
                    </div>
                  </div>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </template>
        </md-card-content>
      </md-card>
    </div>

    <!-- Change Type Dialog -->

    <InsertLogDialog
      :workPlaces="workPlaces"
      :insertLoading="insertLoading"
      :showInsertLogDialog.sync="showInsertLogDialog"
      :parentEmployeeId.sync="employeeId"
      @closeDialog="closeInsertLogDialog"
      @confirm-change="insertLogHandler"
    />
    <ChangeSignTypeDialog
      :selectedItem.sync="selectedItem"
      :newSignType.sync="newSignType"
      :showChangeTypeDialog.sync="showChangeTypeDialog"
      :shiftList.sync="shiftList"
      @close-change-type-dialog="closeChangeTypeDialog"
      @confirm-change="confirmChange"
    />
  </div>
</template>

<script>
import { ModelListSelect } from "vue-search-select";
import moment from "moment";
import ChangeSignTypeDialog from "@/components/ChangeSignTypeDialog.vue";
import InsertLogDialog from "@/components/InsertLogDialog.vue";
import Swal from "sweetalert2";

const SIGN_MECHANISM = { MANUAL: 1, INSERTED: 2, SELF: 3 };

export default {
  components: {
    ModelListSelect,
    ChangeSignTypeDialog,
    InsertLogDialog,
  },
  async mounted() {
    await this.fetchWorkPlaces();
  },
  computed: {
    employeesList() {
      const lists = this.$store.getters["global/employeesData"];
      return lists?.employees || [];
    },
    toPage() {
      let highBound = this.fromPage + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    fromPage() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.tableData.length;
    },
    currentEmployeeIndex() {
      return this.employeesList.findIndex((e) => e.key === this.employeeId);
    },
    areFieldsFilled() {
      return this.employeeId && this.from && this.to;
    },
    isBackDisabled() {
      return !this.areFieldsFilled || this.currentEmployeeIndex <= 0;
    },
    isNextDisabled() {
      return (
        !this.areFieldsFilled ||
        this.currentEmployeeIndex >= this.employeesList.length - 1
      );
    },
  },
  data() {
    return {
      shiftList: [],
      isFetchShiftListLoading: false,
      shiftId: null,
      insertLoading: false,
      workPlaces: [],
      canClear: false,
      isLoading: false,
      employeeId: null,
      JobNumber: null,
      from: null,
      to: new Date(),
      employees: [],
      tableData: [],
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      currentSort: "Titel",
      currentSortOrder: "asc",
      showChangeTypeDialog: false,
      selectedItem: null,
      newSignType: 1,
      showInsertLogDialog: false,
      showSkippedLogs: false,
    };
  },
  watch: {
    employeeId(newValue, oldValue) {
      if (newValue) {
        this.fetchShiftList(newValue);
      }
      if (this.canClear) {
        this.JobNumber = null;
      }

      this.canClear = false;
    },
    JobNumber(newValue, oldValue) {
      if (this.canClear) {
        this.employeeId = null;
      }
      this.canClear = false;
    },
  },
  methods: {
    isInsertedSign(item) {
      return item.signMechanism === SIGN_MECHANISM.INSERTED;
    },
    goToNextEmployee() {
      if (this.isNextDisabled) return;
      this.employeeId = this.employeesList[this.currentEmployeeIndex + 1].key;
      this.JobNumber = null;
      this.search();
    },
    goToPreviousEmployee() {
      if (this.isBackDisabled) return;
      this.employeeId = this.employeesList[this.currentEmployeeIndex - 1].key;
      this.JobNumber = null;
      this.search();
    },
    async fetchShiftList(id) {
      try {
        this.isLoading = true;
        const { data } = await this.$axios.get(
          `/api/hr/employees/LoadEmployeeShifts?employeeId=${id}`
        );
        this.shiftList = data.data;
      } catch (error) {
      } finally {
        this.isLoading = false;
      }
    },
    async fetchWorkPlaces() {
      const { data } = await this.$axios.get("/api/workPlaces");
      this.workPlaces = data.data;
    },
    async confirmChange(event) {
      const id = event.selectedItem.id;

      let schema = {
        signType: event.newSignType,
        status: event.status,
      };

      if (event.shiftId) {
        schema.shiftId = event.shiftId;
      }

      try {
        const { data } = await this.$axios.put(
          `/api/attendance/${id}`,
          schema,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (data) {
          this.notifyVue("top", "center", "success", data.message);
          this.search();
        }
      } catch (error) {
        console.error("error", error);
      }
    },

    clearInput() {
      this.canClear = true;
    },

    async search() {
      try {
        if (!this.employeeId && !this.JobNumber) {
          return this.notifyVue(
            "top",
            "center",
            "warning",
            "يرجى ادخال الموظف أو رقم الموظف"
          );
        }
        if (!this.from) {
          return this.notifyVue(
            "top",
            "center",
            "warning",
            "يرجى اختيار تاريخ من "
          );
        }
        if (!this.to) {
          return this.notifyVue(
            "top",
            "center",
            "warning",
            "يرجى اختيار تاريخ إلى "
          );
        }

        this.isLoading = true;

        const fromDate = this.from
          ? moment(this.from).format("YYYY-MM-DD")
          : null;
        const toDate = this.to ? moment(this.to).format("YYYY-MM-DD") : null;

        const params = {
          employeeId: this.employeeId,
          jobNumber: this.JobNumber,
          from: fromDate,
          to: toDate,
          showSkippedLogs: this.showSkippedLogs,
        };

        const { data } = await this.$axios.get("/api/attendance", {
          params,
        });

        this.canClear = false;
        this.employeeId = data.data.employeeId;
        this.JobNumber = data.data.employeeNumber;

        this.tableData = data.data.signs;
      } catch (error) {
        this.notifyVue("top", "center", "warning", error.response.data.message);
      } finally {
        this.isLoading = false;
        this.$nextTick(() => {
          this.canClear = false;
        });
      }
    },

    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
      } catch (error) {}
    },

    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },

    getRowStyle(item, index) {
      if (item.status == 2) return {};

      const nextItem = this.tableData[index + 1];
      const prevItem = this.tableData[index - 1];

      const matchesNext =
        nextItem && nextItem.signType == item.signType && nextItem.status != 2;

      const matchesPrev =
        prevItem && prevItem.signType == item.signType && prevItem.status != 2;

      if (matchesNext || matchesPrev) {
        return { "background-color": "#fcf8de" };
      }
      return {};
    },

    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },

    openChangeTypeDialog(item) {
      this.selectedItem = item;
      this.newSignType = item.signType; // تعيين القيمة الحالية كافتراضية
      this.showChangeTypeDialog = true;
    },

    closeChangeTypeDialog() {
      this.showChangeTypeDialog = false;
      this.selectedItem = null;
    },

    getOppositeType(signType) {
      return signType === 1 ? "خروج" : "دخول";
    },

    openInsertLogDialog() {
      this.showInsertLogDialog = true;
    },

    closeInsertLogDialog() {
      this.showInsertLogDialog = false;
    },

    async insertLogHandler(data) {
      try {
        this.insertLoading = true;
        const schema = {
          ...data,
          day: moment(data.day).format("YYYY-MM-DD"),
        };

        const { data: res } = await this.$axios.post(
          "api/Attendance/InsertLog",
          schema
        );

        this.notifyVue("top", "center", "success", res.message);

        if (res.data) {
          this.closeInsertLogDialog();
        }
      } catch (error) {
      } finally {
        this.insertLoading = false;
      }
    },

    async handleIgnore(item) {
      try {
        Swal.fire({
          text: "سيتم تجاهل هذه البصمة، هل أنت متأكد؟",
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-success btn-fill",
          cancelButtonClass: "md-button md-danger btn-fill",
          confirmButtonText: "نعم",
          cancelButtonText: "لا",
          buttonsStyling: false,
        }).then(async (result) => {
          if (result.value) {
            try {
              const { data } = await this.$axios.put(
                `/api/attendance/${item.id}`,
                {
                  signType: item.signType,
                  status: 2,
                },
                {
                  headers: {
                    "Content-Type": "application/json",
                  },
                }
              );

              if (data) {
                this.notifyVue("top", "center", "success", data.message);
                this.search();
              }
            } catch (error) {
              this.notifyVue(
                "top",
                "center",
                "danger",
                error?.response?.data?.message || "حدث خطأ أثناء تجاهل البصمة"
              );
            }
          }
        });
      } catch (error) {
        this.notifyVue(
          "top",
          "center",
          "danger",
          error?.response?.data?.message || "حدث خطأ أثناء تجاهل البصمة"
        );
      }
    },

    async handleDelete(item) {
      try {
        Swal.fire({
          text: "سيتم الحذف هل انت متأكد ؟",
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-success btn-fill",
          cancelButtonClass: "md-button md-danger btn-fill",
          confirmButtonText: "نعم",
          cancelButtonText: "لا",
          buttonsStyling: false,
        }).then(async (result) => {
          if (result.value) {
            try {
              const { data } = await this.$axios.delete(
                `/api/attendance/${item.id}`
              );

              if (data) {
                this.search();
              }
            } catch (error) {
              this.notifyVue(
                "top",
                "center",
                "danger",
                error?.response?.data?.message || "حدث خطأ أثناء الحذف"
              );
            }
          }
        });
      } catch (error) {
        this.notifyVue(
          "top",
          "center",
          "danger",
          error?.response?.data?.message || "حدث خطأ أثناء الحذف"
        );
      }
    },

    async exportReport(reportType) {
      try {
        if (!this.employeeId && !this.JobNumber) {
          return this.notifyVue(
            "top",
            "center",
            "warning",
            "يرجى ادخال الموظف أو رقم الموظف"
          );
        }
        if (!this.from) {
          return this.notifyVue(
            "top",
            "center",
            "warning",
            "يرجى اختيار تاريخ من "
          );
        }
        if (!this.to) {
          return this.notifyVue(
            "top",
            "center",
            "warning",
            "يرجى اختيار تاريخ إلى "
          );
        }

        this.isLoading = true;

        const fromDate = this.from
          ? moment(this.from).format("YYYY-MM-DD")
          : null;
        const toDate = this.to ? moment(this.to).format("YYYY-MM-DD") : null;

        const schema = {
          EmployeeId: this.employeeId,
          JobNumber: this.JobNumber,
          From: fromDate,
          To: toDate,
          showSkippedLogs: this.showSkippedLogs,
          ReportType: reportType,
        };

        const { data } = await this.$axios.patch(
          "/api/attendance/AttendanceReport",
          schema,
          {
            responseType: "blob",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        // Create a download link for the file
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;

        const employee = this.employeesList.find(
          (emp) => emp.key === this.employeeId
        );

        // Set filename based on report type
        const fileName = `تقرير سجل الحضور والانصراف - ${employee?.value}.${
          reportType === "PDF" ? "pdf" : "xlsx"
        }`;
        link.setAttribute("download", fileName);

        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        this.notifyVue(
          "top",
          "center",
          "success",
          `تم تنزيل التقرير بصيغة ${reportType} بنجاح`
        );
      } catch (error) {
        this.notifyVue(
          "top",
          "center",
          "danger",
          error?.response?.data?.message || "حدث خطأ أثناء تصدير التقرير"
        );
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-style {
  width: fit-content;
  height: 40px;
  line-height: 60px;
}

.mb-20 {
  margin-bottom: 20px;
}

.mb-15 {
  margin-bottom: 15px;
}

.mb-10 {
  margin-bottom: 10px;
}

.actions-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.action-slot {
  width: 40px;
  display: flex;
  justify-content: center;
}

.employee-nav-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  gap: 15px;
}

.employee-nav-btn {
  min-width: 120px;
}
</style>
